import React from "react";
import InfoAccordion from "./InfoAccordion";
import DetailField from "./DetailField";

export default function RiderInformation({ singleOrder }) {
  // Show the most recently assigned courier
  const lastCourierOrder =
    singleOrder?.courier_orders?.[singleOrder?.courier_orders?.length - 1];
  const courier = lastCourierOrder?.courier;

  return (
    <InfoAccordion
      parentId="accordionRider"
      itemId="accordion-item-icon-right-3"
      title="Riders Information"
    >
      <div className="Rider_contact">
        <div className="d-flex">
          <div className="mr-4">
            <div className="alternative-image">
              {courier?.courier_name?.charAt(0)}
            </div>
          </div>
          <div className="px-2 w-100">
            <div className="row">
              <DetailField
                label="Name:"
                value={courier?.courier_name}
                colClassName="col-md-4 mb-2 mt-3"
                detailsClassName="rider-details"
                valueClassName="text-capitalize"
              />
              <DetailField
                label="Phone:"
                value={courier?.courier_phone}
                colClassName="col-md-4 mb-2 mt-3"
                detailsClassName="rider-details"
              />
            </div>
          </div>
        </div>
      </div>
    </InfoAccordion>
  );
}
